import { Grid, Typography, Rating } from "@mui/material";

import IRatingList from "../../interface/iRatingList";
import React from "react";
import getStarColor from "../../../../functions/getStarColor";

const StarCategories = ({
  rating,
}: {
  rating: IRatingList;
}): React.JSX.Element => (
  <Grid container item xs={12}>
    <Grid container item xs={12} sm={6} md={10} rowSpacing={0.5}>
      <Grid item xs={12} sm={6} md={9}>
        <Typography variant="body1" color="initial">
          Der Coach gestaltete unsere Zusammenarbeit wertschätzend und
          professionell
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
        <Rating
          precision={1}
          readOnly
          name="size-large"
          defaultValue={2}
          size="medium"
          value={rating.starsCollaboration}
          sx={{
            color: getStarColor(rating.starsCollaboration),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={9}>
        <Typography variant="body1" color="initial">
          Im Coaching konnte ich meine offenen Fragen klären
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
        <Rating
          precision={1}
          readOnly
          name="size-large"
          defaultValue={2}
          size="medium"
          value={rating.starsCollaboration}
          sx={{
            color: getStarColor(rating.starsClarifyingOpenQuestions),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={9}>
        <Typography variant="body1" color="initial">
          Durch das Coaching fühle ich mich im Bewerbungsprozess sicherer
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
        <Rating
          precision={1}
          readOnly
          name="size-large"
          defaultValue={2}
          size="medium"
          value={rating.starsApplicationProcess}
          sx={{
            color: getStarColor(rating.starsApplicationProcess),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={9}>
        <Typography variant="body1" color="initial">
          Durch das Coaching bin ich mir meiner Kompetenzen und Stärken
          bewusster geworden
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
        <Rating
          precision={1}
          readOnly
          name="size-large"
          defaultValue={2}
          size="medium"
          value={rating.starsCompetencies}
          sx={{
            color: getStarColor(rating.starsCompetencies),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={9}>
        <Typography variant="body1" color="initial">
          Durch das Coaching konnte ich zielorientierte Bewerbungsunterlagen
          erstellen
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
        <Rating
          precision={1}
          readOnly
          name="size-large"
          defaultValue={2}
          size="medium"
          value={rating.starsApplicationDocuments}
          sx={{
            color: getStarColor(rating.starsApplicationDocuments),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={9}>
        <Typography variant="body1" color="initial">
          Ich würde das Onlinebewerbungscoaching weiterempfehlen
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
        <Rating
          precision={1}
          readOnly
          name="size-large"
          defaultValue={2}
          size="medium"
          value={rating.starRatingRecommend}
          sx={{
            color: getStarColor(rating.starRatingRecommend),
          }}
        />
      </Grid>
    </Grid>
    <Grid
      item
      xs={12}
      sm={6}
      md={2}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="h3"
        color="initial"
        sx={{
          fontWeight: "bold",
        }}
      >
        {rating.averageRating}&#8960;
      </Typography>
    </Grid>
  </Grid>
);

export default StarCategories;
